/**
 * Class representing a point ranking entry.
 * @abstract
 */
export class PointRankingEntry {
	constructor(entry) {
		/**
		 * @type {int|float}
		 */
		this.score = entry.score;
		/**
		 * @type {(int|float)[]}
		 */
		this.scores = [this.score];
	}
}
